import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './_cvcTooltip.css'
import { FormattedMessage } from 'react-intl'
import Svg from 'components/util/Svg'
import cvcBack from 'images/cvcBack.png'
import cvcFront from 'images/cvcFront.png'
import enhanceWithClickOutside from 'react-click-outside'

export class CvcTooltip extends Component {

  static propTypes = {
    onClickOutside: PropTypes.func,
    style: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  };

  handleClickOutside (...args) {
    const callback = this.props.onClickOutside
    if (callback && typeof callback === 'function') {
      return callback(...args)
    }
  }

  render () {
    const { style } = this.props

    return (
      <div className={styles.container} style={style}>
        <h3 className={styles.title}>
          <FormattedMessage
            id='premium.checkout.cvcTooltip.title'
            defaultMessage='Where is the Security Code?'
          />
        </h3>

        <div className={styles.body}>
          <div className={styles.side}>
            <div className={styles.cards}>
              <Svg name='visa' height={28} width={43} style={{ marginRight: 5 }} />
              <Svg name='mastercard' height={28} width={43} />
            </div>
            <div className={styles.cardFace}><img width='54' height='33' src={cvcBack} alt='' /></div>
            <h4 className={styles.subtitle}>
              <FormattedMessage
                id='premium.checkout..back'
                defaultMessage='Back of card'
              />
            </h4>
            <p>
              <FormattedMessage
                id='premium.checkout..backDescription'
                defaultMessage='Three digits located to the right of the signature strip.'
              />
            </p>
          </div>
          <div className={styles.side}>
            <div className={styles.cards}>
              <Svg name='american-express' height={28} width={43} />
            </div>
            <div className={styles.cardFace}><img width='54' height='33' src={cvcFront} alt='' /></div>
            <h4 className={styles.subtitle}>
              <FormattedMessage
                id='premium.checkout.cvcTooltip.front'
                defaultMessage='Front of card'
              />
            </h4>
            <p>
              <FormattedMessage
                id='premium.checkout.cvcTooltip.frontDescription'
                defaultMessage='Four digits printed on either the left or right side.'
              />
            </p>
          </div>
        </div>
      </div>
    )
  }

}

export default enhanceWithClickOutside(CvcTooltip)



// WEBPACK FOOTER //
// ./src/components/premium/CCForm/CVCTooltip.jsx